import { render, staticRenderFns } from "./EditUpsellItemPage.vue?vue&type=template&id=446916c2&scoped=true&"
import script from "./EditUpsellItemPage.vue?vue&type=script&lang=js&"
export * from "./EditUpsellItemPage.vue?vue&type=script&lang=js&"
import style0 from "./EditUpsellItemPage.vue?vue&type=style&index=0&id=446916c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446916c2",
  null
  
)

export default component.exports